import { useState } from "react";
import './css/Header.css'

function Header({ onLogout }) {
    const [language, setLanguage] = useState("fr"); // Langue par défaut : Français

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        console.log("Langue changée en :", lang);
        // Si tu utilises i18next :
        // i18n.changeLanguage(lang);
    };

    return (
        <div>
            {/* Navbar */}
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                {/* Left navbar links */}
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#" role="button">
                            <i className="fas fa-bars" />
                        </a>
                    </li>
                    <li className="nav-item d-none d-sm-inline-block">
                        <a href="/" className="nav-link">Accueil</a>
                    </li>
                    <li className="nav-item d-none d-sm-inline-block">
                        <a href="#" className="nav-link">Contact</a>
                    </li>
                </ul>

                {/* Right navbar links */}
                <ul className="navbar-nav ml-auto">
                    {/* Notifications Dropdown */}
                    <li className="nav-item dropdown">
                        <a className="nav-link" data-toggle="dropdown" href="#">
                            <i className="far fa-bell" />
                            <span className="badge badge-secondary navbar-badge">15</span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                            <span className="dropdown-item dropdown-header">15 Notifications</span>
                            <div className="dropdown-divider" />
                            <a href="#" className="dropdown-item">
                                <i className="fas fa-envelope mr-2" /> 4 nouveaux messages
                                <span className="float-right text-muted text-sm">3 mins</span>
                            </a>
                            <div className="dropdown-divider" />
                            <a href="#" className="dropdown-item">
                                <i className="fas fa-users mr-2" /> 8 demandes d'amis
                                <span className="float-right text-muted text-sm">12 heures</span>
                            </a>
                            <div className="dropdown-divider" />
                            <a href="#" className="dropdown-item">
                                <i className="fas fa-file mr-2" /> 3 nouveaux rapports
                                <span className="float-right text-muted text-sm">2 jours</span>
                            </a>
                            <div className="dropdown-divider" />
                            <a href="#" className="dropdown-item dropdown-footer">Voir toutes les notifications</a>
                        </div>
                    </li>

                    {/* Language Switcher Dropdown */}
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
                            <i className="fas fa-globe"></i> {language === "fr" ? "Français" : "العربية"}
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                            <button
                                className={`dropdown-item ${language === "fr" ? "active font-weight-bold" : ""}`}
                                onClick={() => handleLanguageChange("fr")}
                            >
                                Français {language === "fr" && "✅"}
                            </button>
                            <button
                                className={`dropdown-item ${language === "ar" ? "active font-weight-bold" : ""}`}
                                onClick={() => handleLanguageChange("ar")}
                            >
                                العربية {language === "ar" && "✅"}
                            </button>
                        </div>
                    </li>

                    {/* Logout Button */}
                    <li className="nav-item">
                        <button className="btn btn-secondary ml-3" onClick={onLogout}>
                            <i className="fas fa-sign-out-alt"></i> Déconnexion
                        </button>
                    </li>
                </ul>
            </nav>
            {/* /.navbar */}
        </div>
    );
}

export default Header;